import { AnalyticsEvent } from "./events"
import { MixpanelTracking } from "./mixpanel"
import { SentryTracking } from "./sentry"

export { AnalyticsEvent } from "./events"

export const Analytics = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  track(name: AnalyticsEvent, data: Record<string, any> = {}) {
    MixpanelTracking.track(name, data)
    SentryTracking.track(name, data)
  },
}
